import * as React from 'react'
import { Pane } from 'evergreen-ui'
import { useCustomTheme } from '/fiweb/lib/theme'
import { Divider } from '/fiweb/components'

const Skeleton = () => {
  const theme = useCustomTheme()
  return (
    <>
      <Pane width='100%' height={238} background='blue50' />
      <Pane width={250} height={20} borderRadius={10} background='default' margin={theme.spacing.s} opacity={0.3} />
      <Pane width='calc(100% - 60)' height={15} borderRadius={10} background='default' marginX={30} opacity={0.2} />
      <Pane
        width='calc(100% - 60)'
        height={15}
        borderRadius={10}
        background='default'
        marginX={30}
        marginTop={theme.spacing.xxs}
        opacity={0.2}
      />

      <Divider marginTop={theme.spacing.l} marginBottom={theme.spacing.xs} marginX={30} />
    </>
  )
}

export default Skeleton
